<template>
  <HvhModal :value="true" :title="`Manage [${group.name}] Permissions`" @input="$emit('input', false)">
    <div class="hvh-flex">
      <v-select class="mr-3" v-model="newPermission.groupFrom.id" :items="userGroups" label="Group Name" itemText="name" itemValue="id" outline hide-details />
      <v-select class="mr-3" v-model="newPermission.permissionType" label="Permissions" :items="['All', 'View', 'Delete']" outline hide-details />
      <div class="hvh-flex column align-center mr-3">
        <HvhInputCheckbox class="mb-0" v-model="newPermission.revoke" label="Permissions" :items="['All', 'View', 'Delete']" outline hide-details />
        Revoke
      </div>
      <v-btn :class="{ disabled: !newPermission.groupFrom.id || !newPermission.permissionType }" flat="flat" large outline @click="addPermission">Add</v-btn>
    </div>
    <DataTableAsync :data="permissions" v-model="tableState" :length="count" noSearch>
      <template #head>
        <tr>
          <th>Group Name</th>
          <th>Permissions</th>
          <th>Revoked</th>
          <th />
        </tr>
      </template>
      <template #body="{ item }">
        <tr>
          <td>{{ item.groupFrom.name }}</td>
          <td class="text-center">{{ item.permissionType }}</td>
          <td class="text-center">{{ item.revoke ? 'Yes' : 'No' }}</td>
          <td class="link text-center" @click="deleteObject(item)">Delete</td>
        </tr>
      </template>
    </DataTableAsync>
    <Loader v-if="!userGroups" />
  </HvhModal>
</template>

<script>
import axios from '../../axios';
import { errorDebug } from '../../libraries/common';
import DataTableAsync from '../common/dataTable/DataTableAsync.vue';
import HvhModal from '../common/modal/HvhModal.vue'
export default {
  components: { HvhModal, DataTableAsync, },
  props: ['group',],
  data() {
    return {
      userGroups: null,

      permissions: null,
      tableState: { page: 1, perPage: 50 },
      count: 50,
      newPermission: { groupFrom: {} },
    };
  },
  methods: {
    getUserGroups() {
      return axios.get('/Permissions/Group', { params: { type: 'DatabaseModels.Models.ApplicationUser' } })
        .then(response => this.userGroups = response.data)
        .catch(errorDebug);
    },
    getData() {
      axios.get('/Permissions/Permission', { params: { groupToId: this.group.id } })
        .then(response => this.permissions = response.data)
        .catch(errorDebug);
    },
    addPermission() {
      axios.post('/Permissions/Permission', { ...this.newPermission, groupTo: { id: this.group.id } })
        .then(response => {
          this.permissions = [...this.permissions, response.data];
          this.newPermission = { groupFrom: {} };
        })
        .catch(errorDebug);
    },
    deleteObject(permission) {
      axios.delete(`/Permissions/Permission/${permission.id}`)
        .then(() => this.permissions = this.permissions.filter(f => f.id !== permission.id))
        .catch(errorDebug);
    },
    save() {
      debugger;
    },

    userGroupById(id) {
      return this.userGroups.find(f => f.id === id);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisManagePermissions'] = this;
    this.getUserGroups()
      .then(this.getData);
  },
}
</script>

<style lang="scss" scoped>
.link {
  color: #002f6c;
  text-decoration: underline #002f6c;
  cursor: pointer;
}
</style>